<script>
import {Head, Link} from "@inertiajs/vue3";

export default {
  components: {
    Head,
    Link
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <Head :title="title"/>

  <!-- ============================================================== -->
  <!-- Main wrapper - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <section id="wrapper">
    <div class="login-register" style="background-image:url(/assets/images/background/login-register.jpg);">
      <div class="login-box card">
        <div class="card-body">
          <h3 class="text-center m-b-20">{{ title }}</h3>

          <slot></slot>


        </div>
      </div>
    </div>
  </section>

  <div data-message-container class="toast-container top-0 end-0 p-2 p-lg-4 position-fixed message-wrapper"></div>
  <div data-alert-container></div>
</template>